<ng-container *ngIf="externalInfluencerService.externalInfluencer$ | async as externalInfluencer">
    <h6 *collapsible="content" class="u-color-muted u-margin-bottom-half">{{ 'ABOUT.LABEL_SHORT' | translate }}</h6>
    <ng-template #content>
        <p
            class="u-color-muted u-font-size-small"
            [innerHtml]="'ABOUT.TEXT_SHORT' | translate: { realEstateGroup: externalInfluencer.name }"
        ></p>
    </ng-template>
</ng-container>
